import React, { useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import moment from "moment";

const CalendarFC = () => {
  const [events] = useState([
    { id: 1, title: "Order no. 1845123", date: "2025-11-08", type: "Wedding" },
    { id: 2, title: "Order no. 1845196", date: "2025-11-08", type: "Corporate events" },
    { id: 3, title: "Order no. 1845197", date: "2025-11-09", type: "Birthdays" },
  ]);

  // Color palette for your types
  const getBgColor = (type) => {
    switch (type) {
      case "Wedding":
        return "#324c7e";
      case "Corporate events":
        return "#e50707";
      default:
        return "#2b7b01";
    }
  };

  return (
    <div className="fullcalendar-wrapper">
     <FullCalendar
  plugins={[dayGridPlugin]}
  timeZone="local"
  initialView="dayGridMonth"

  selectable={false}              // << disable date range selection
  selectOverlap={false}
  longPressDelay={999999}
  selectMinDistance={999999}

  events={events.map((ev) => ({
    ...ev,
    start: ev.date + "T00:00:00",
    allDay: true,
    backgroundColor: getBgColor(ev.type),
    borderColor: "transparent",
  }))}

  dateClick={(info) => {
    console.log("Clicked:", info.dateStr); // will now show correct date
  }}

  headerToolbar={{
    left: "prev",
    center: "title",
    right: "next",
  }}

  titleFormat={{ year: "numeric", month: "long" }}
  height="auto"
  dayMaxEventRows={3}
/>

    </div>
  );
};

export default CalendarFC;
